import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { updateWorkstationSuccess } from '../../../store/shipstation-connect/ss-connect.actions';
import { updateConfigByDeviceType, updateWorkstation } from '../api/ss-connect';

import Workstation from './workstation';
import EditModal from './edit-device-modal';
import { WorkstationPropType } from './prop-types';
import { WORKSTATION } from './constants';
import { emptyArray } from 'ui-components/default-props/empty';

const ConnectedWorkstations = ({ workstations, shouldShowPrintersAndScales = false, currentUserWorkstationIds = emptyArray }) => {
  const dispatch = useDispatch();
  const [selectedDevice, setDevice] = useState();
  const [deviceType, setDeviceType] = useState();

  const openModalForDeviceType = useCallback((device, dt) => {
    setDeviceType(dt);
    setDevice(device);
  }, []);

  const closeModal = useCallback(() => {
    setDevice(null);
  }, []);

  const onSave = useCallback(
    (device) => {
      const workstation = workstations.find((ws) => ws.workstationId === device.workstationId);
      if (deviceType === WORKSTATION) {
        updateWorkstation({
          workstationId: device?.workstationId,
          description: device?.description,
        }).then((updatedWorkstation) => dispatch(updateWorkstationSuccess(updatedWorkstation)));
      } else {
        updateConfigByDeviceType[deviceType]({
          device,
          workstationId: device.workstationId,
          userId: workstation.userId,
          description: device.description,
        });
      }
    },
    [workstations, deviceType, dispatch],
  );

  return (
    <>
      {workstations.map((ws) => (
        <Workstation
          key={ws.workstationId}
          currentUserWorkstationIds={currentUserWorkstationIds}
          openModalForDeviceType={openModalForDeviceType}
          shouldShowPrintersAndScales={shouldShowPrintersAndScales}
          workstation={ws}
        />
      ))}
      {selectedDevice && (
        <EditModal device={selectedDevice} deviceType={deviceType} onClose={closeModal} onSave={onSave} setDevice={setDevice} />
      )}
    </>
  );
};

ConnectedWorkstations.propTypes = {
  workstations: PropTypes.arrayOf(WorkstationPropType).isRequired,
  shouldShowPrintersAndScales: PropTypes.bool,
  currentUserWorkstationIds: PropTypes.arrayOf(PropTypes.string),
};

export default ConnectedWorkstations;
